import React from "react"

const SocialIconDribbble = ({
  className = "",
  width = "auto",
  height = "auto",
  fill,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m12 23.9719c-6.61875 0-12-5.3719-12-11.9813 0-6.61872 5.38125-11.9906 12-11.9906 6.6187 0 12 5.37188 12 11.9813 0 6.6093-5.3813 11.9906-12 11.9906zm10.1156-10.35c-.3469-.1125-3.1687-.9469-6.3843-.4406 1.3406 3.675 1.8843 6.6749 1.9875 7.2937 2.3062-1.5469 3.9468-4.0031 4.3968-6.8531zm-6.1125 7.8c-.15-.9-.75-4.0313-2.1844-7.7625-.0187.0093-.0468.0187-.0656.0187-5.78435 2.0156-7.85622 6.0188-8.04372 6.3938 1.73437 1.35 3.91875 2.1562 6.29062 2.1562 1.4156.0094 2.775-.2812 4.0031-.8062zm-11.6156-2.5781c.23437-.3938 3.04687-5.0438 8.3344-6.7594.1312-.0469.2719-.0844.4031-.1219-.2531-.5813-.5344-1.1625-.8344-1.7344-5.11872 1.5281-10.08747 1.4625-10.53747 1.4531 0 .1032-.00938.2063-.00938.3094.00938 2.6344 1.00312 5.0344 2.64375 6.8532zm-2.41875-8.9438c.45938.00937 4.67812.02813 9.47815-1.24687-1.6969-3.01875-3.5344-5.55-3.7969-5.91563-2.87813 1.35-5.01563 3.99375-5.68125 7.1625zm7.63125-7.85625c.28125.375 2.1469 2.90625 3.825 5.99062 3.6469-1.36875 5.1844-3.43125 5.3719-3.69375-1.8094-1.60312-4.1907-2.57812-6.7969-2.57812-.825 0-1.6312.10312-2.4.28125zm10.3313 3.47813c-.2157.29062-1.9313 2.49374-5.7188 4.04062.2344.4875.4687.9844.6844 1.4813.075.1781.15.3562.225.525 3.4125-.4313 6.7968.2625 7.1343.3281-.0281-2.4094-.8906-4.63127-2.3249-6.37502z"
        fill={fill}
      />
    </svg>
  )
}

export default SocialIconDribbble
